import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import * as CanvasFunctions from '../../components/CanvasFunctions';
import classNames from 'classnames';
import '../../../../../styles/canvas.css';

import {
    Card,
    CardContent,
    CardActions,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from '@material-ui/core';

const styles = theme => ({
    
});

class CanvasEditor extends React.Component {
    svgRef = React.createRef();

    state = {
        tool_type:         "drag",
        obj_list:          [], // Internal Object list is used to prevent lag when multiple hot-spot questions are present 
        current_obj_id:    0,
        current_tool_type: null,
        obj_inc:           1,
        drag_start:        {},
        canvasMouseIcon:   "default",
        current_svg_coord: {},
    }
    
    onResize = () => {
        let relative_obj_list = CanvasFunctions.getRelativeCoordinatesForObjList(this.state.obj_list, this.state.current_svg_coord);

        this.setState({
            obj_list: CanvasFunctions.parseRelativeCoordinatesForObjList(relative_obj_list, this.svgRef.current.getBoundingClientRect()),
            current_svg_coord: this.svgRef.current.getBoundingClientRect()
        });
        this.forceUpdate();

    }

    componentDidMount = () => {
        // window.addEventListener("resize", this.onResize);

        const svgCoord = this.svgRef.current.getBoundingClientRect();
        this.setState({
            obj_list: CanvasFunctions.parseRelativeCoordinatesForObjList(this.props.question.image.shape_list, svgCoord),
            current_svg_coord: svgCoord,
        });
    }

    incrementObjCount = () => {
        const current_obj_count = this.state.obj_inc;

        this.setState({
            obj_inc: (current_obj_count + 1)
        });
        
        return current_obj_count;
    }

    handleSelectTool = (tool_type) => {
        this.setState({
            tool_type: tool_type
        });
    }

    removeObj = (obj_id) => {
        const new_obj_list = this.state.obj_list.filter((obj_info) => obj_info.id !== obj_id);

        this.setState({
            obj_list: new_obj_list
        });

        this.props.replaceQuestionImageShape(this.props.question.header.question_id, new_obj_list);
    }

    getFixedStartEndCoord = (obj_list, obj_id) => {
        return obj_list.map((obj_info) => {
            if (obj_info.id === obj_id) {
                let new_obj = obj_info;

                // Reverse X coordinates if needed
                if (new_obj.xStart > new_obj.xEnd) {
                    new_obj = {
                        ...new_obj,
                        xStart: new_obj.xEnd,
                        xEnd:   new_obj.xStart,
                    }
                }

                // Reverse Y coordinates if needed
                if (new_obj.yStart > new_obj.yEnd) {
                    new_obj = {
                        ...new_obj,
                        yStart: new_obj.yEnd,
                        yEnd:   new_obj.yStart,
                    }
                }

                return new_obj;
            } else {
                return obj_info;
            }
        })
    }

    handleMouseDownObj = (event, obj_info) => {
        const { canvasMouseIcon } = this.state;

        this.setState({
            current_obj_id:    obj_info.id,
            current_tool_type: canvasMouseIcon,
            drag_start: {
                x: event.clientX,
                y: event.clientY,
            }
        })
    }

    handleMouseUpObj = (event, obj_info) => {
        this.setState({
            obj_list:       this.getFixedStartEndCoord(this.state.obj_list, this.state.current_obj_id),
            current_obj_id: 0,
            drag_start:     {},
        })
    }

    handleMouseDown = (event) => {
        const { question } = this.props;
        const { tool_type } = this.state;
        const { shiftKey } = event;
        const { x: xStart, y: yStart } = CanvasFunctions.getCoords(event, this.svgRef.current.getBoundingClientRect());

        let new_obj = {};
        switch(tool_type)
        {
            case("rectangle"):
            {
                new_obj = {
                    id:     this.incrementObjCount(),
                    type:   "rectangle",
                    bg:     "rgb(33, 255, 0)",
                    xStart: xStart,
                    yStart: yStart,
                    xEnd:   xStart,
                    yEnd:   yStart,
                    locked: shiftKey,
                }

                this.setState({
                    obj_list: [...this.state.obj_list, new_obj],
                    current_obj_id: new_obj.id,
                    current_tool_type: new_obj.type,
                });

                break;
            }

            case("circle"):
            {
                new_obj = {
                    id:     this.incrementObjCount(),
                    type:   "circle",
                    bg:     "rgb(33, 255, 0)",
                    xStart: xStart,
                    yStart: yStart,
                    xEnd:   xStart,
                    yEnd:   yStart,
                    locked: shiftKey,
                }

                this.setState({
                    obj_list: [...this.state.obj_list, new_obj],
                    current_obj_id: new_obj.id,
                    current_tool_type: new_obj.type,
                });

                break;
            }
        }
    }

    handleMouseMove = (event) => {
        const { obj_list, current_obj_id, current_tool_type, drag_start } = this.state;
        const { x: xEnd, y: yEnd } = CanvasFunctions.getCoords(event, this.svgRef.current.getBoundingClientRect());

        this.setCanvasMouseIcon(xEnd, yEnd);

        switch(current_tool_type)
        {
            case("rectangle"):
            {
                this.setState({
                    obj_list: obj_list.map((obj_info) => {
                        if (obj_info.id === current_obj_id) {
                            return {
                                ...obj_info,
                                xEnd:   xEnd,
                                yEnd:   yEnd,
                                locked: event.shiftKey
                            }
                        } else {
                            return obj_info;
                        }
                    })
                });
                break;
            }

            case("circle"):
            {
                this.setState({
                    obj_list: obj_list.map((obj_info) => {
                        if (obj_info.id === current_obj_id) {
                            return {
                                ...obj_info,
                                xEnd:   xEnd,
                                yEnd:   yEnd,
                                locked: event.shiftKey
                            }
                        } else {
                            return obj_info;
                        }
                    })
                });

                break;
            }

            case("move"):
            {
                const { x: xDragStart, y: yDragStart } = drag_start;
                const { clientX: xDragEnd, clientY: yDragEnd } = event;
                const xDelta = xDragEnd - xDragStart;
                const yDelta = yDragEnd - yDragStart;

                this.setState({
                    drag_start: {
                        x: xDragEnd,
                        y: yDragEnd,
                    },
                    obj_list: this.state.obj_list.map((obj_info) => {
                        if(obj_info.id === this.state.current_obj_id) {
                            return {
                                ...obj_info,
                                xStart: obj_info.xStart + xDelta,
                                xEnd:   obj_info.xEnd   + xDelta,
                                yStart: obj_info.yStart + yDelta,
                                yEnd:   obj_info.yEnd   + yDelta,
                            }
                        } else {
                            return obj_info;
                        }
                    })
                });

                break;
            }

            case ("w-resize"):
            case ("e-resize"):
            case ("n-resize"):
            case ("s-resize"):
            case ("nw-resize"):
            case ("se-resize"):
            case ("ne-resize"):
            case ("sw-resize"):
            {
                const { x: xDragStart, y: yDragStart } = drag_start;
                const { clientX: xDragEnd, clientY: yDragEnd } = event;

                let xDeltaStart = 0;
                let yDeltaStart = 0;
                let xDeltaEnd   = 0;
                let yDeltaEnd   = 0;

                switch (current_tool_type)
                {
                    case ("w-resize"):  xDeltaStart = xDragEnd - xDragStart; break;
                    case ("e-resize"):  xDeltaEnd   = xDragEnd - xDragStart; break;
                    case ("n-resize"):  yDeltaStart = yDragEnd - yDragStart; break;
                    case ("s-resize"):  yDeltaEnd   = yDragEnd - yDragStart; break;
                    case ("nw-resize"): 
                    {
                        xDeltaStart = xDragEnd - xDragStart;
                        yDeltaStart = yDragEnd - yDragStart;
                        break;
                    }
                    case ("se-resize"): 
                    {
                        xDeltaEnd = xDragEnd - xDragStart;
                        yDeltaEnd = yDragEnd - yDragStart;
                        break;
                    }
                    case ("ne-resize"): 
                    {
                        yDeltaStart = yDragEnd - yDragStart;
                        xDeltaEnd   = xDragEnd - xDragStart;
                        break;
                    }
                    case ("sw-resize"): 
                    {
                        xDeltaStart = xDragEnd - xDragStart;
                        yDeltaEnd   = yDragEnd - yDragStart;
                        break;
                    }
                    default: {}
                }

                this.setState({
                    drag_start: {
                        x: xDragEnd,
                        y: yDragEnd,
                    },
                    obj_list: this.state.obj_list.map((obj_info) => {
                        if (obj_info.id === this.state.current_obj_id) {
                            return {
                                ...obj_info,
                                xStart: obj_info.xStart + xDeltaStart,
                                yStart: obj_info.yStart + yDeltaStart,
                                xEnd:   obj_info.xEnd   + xDeltaEnd,
                                yEnd:   obj_info.yEnd   + yDeltaEnd,
                            }
                        } else {
                            return obj_info;
                        }
                    })
                });

                break;
            }
        }
    }

    handleMouseUp = (event) => {
        const { obj_list } = this.state;
        const { question } = this.props;
        
        this.setState({
            obj_list:          this.getFixedStartEndCoord(this.state.obj_list, this.state.current_obj_id),
            tool_type:         "drag",
            current_obj_id:    null,
            current_tool_type: null,
        });
        
        this.props.replaceQuestionImageShape(question.header.question_id, CanvasFunctions.getRelativeCoordinatesForObjList(obj_list, this.svgRef.current.getBoundingClientRect()));
    }

    setCanvasMouseIcon = (mouseX, mouseY) => {
        let mouseIcon = "default";
        let tool_type = this.state.tool_type;
        const offset = 8;
        
        if (this.props.view_type === 'detail') return;

        if (tool_type === 'drag') {
            this.state.obj_list.forEach((obj_info) => {
                if (obj_info.type === "rectangle") {
                    // Left sides of Rectangle
                    if ((mouseX >= (obj_info.xStart) && mouseX <= (obj_info.xStart + offset)) && (mouseY >= obj_info.yStart && mouseY <= obj_info.yEnd)) {
                        mouseIcon = "w-resize";
                    }

                    // Right sides of Rectangle
                    if ((mouseX >= (obj_info.xEnd - offset) && mouseX <= (obj_info.xEnd)) && (mouseY >= obj_info.yStart && mouseY <= obj_info.yEnd)) {
                        mouseIcon = "e-resize";
                    }

                    // Top sides of Rectangle
                    if ((mouseY >= (obj_info.yStart) && mouseY <= (obj_info.yStart + offset)) && (mouseX >= obj_info.xStart && mouseX <= obj_info.xEnd)) {
                        mouseIcon = "n-resize";
                    }

                    // Bottom sides of Rectangle
                    if ((mouseY >= (obj_info.yEnd - offset) && mouseY <= (obj_info.yEnd)) && (mouseX >= obj_info.xStart && mouseX <= obj_info.xEnd)) {
                        mouseIcon = "s-resize";
                    }

                    // Top-Left corners of Rectangle
                    if ((mouseX >= (obj_info.xStart) && mouseX <= (obj_info.xStart + offset)) && (mouseY >= obj_info.yStart && mouseY <= obj_info.yStart + offset)) {
                        mouseIcon = "nw-resize";
                    }

                    // Bottom-Right corners of Rectangle
                    if ((mouseX >= (obj_info.xEnd - offset) && mouseX <= (obj_info.xEnd)) && (mouseY >= obj_info.yEnd - offset && mouseY <= obj_info.yEnd)) {
                        mouseIcon = "se-resize";
                    }

                    // Bottom-Left corners of Rectangle
                    if ((mouseX >= (obj_info.xStart) && mouseX <= (obj_info.xStart + offset)) && (mouseY >= obj_info.yEnd - offset && mouseY <= obj_info.yEnd)) {
                        mouseIcon = "sw-resize";
                    }

                    // Top-Right corners of Rectangle
                    if ((mouseX >= (obj_info.xEnd - offset) && mouseX <= (obj_info.xEnd)) && (mouseY >= obj_info.yStart && mouseY <= obj_info.yStart + offset)) {
                        mouseIcon = "ne-resize";
                    }

                    if ((mouseX >= (obj_info.xStart + offset) && mouseX <= (obj_info.xEnd - offset)) && (mouseY >= (obj_info.yStart + offset) && mouseY <= (obj_info.yEnd - offset))) {
                        mouseIcon = "move";
                    }
                }
            });
        } else {
            mouseIcon = "crosshair";
        }

        this.setState({ 
            canvasMouseIcon: mouseIcon, 
        });
    }


    render() {
        const { tool_type, obj_list } = this.state;
        const { question, view_type } = this.props;
        const background_img = question.image.URL || '';
        const svgKey = window.innerHeight + window.innerWidth;

        const tool_list = [
            { tool_type: 'rectangle', display_name: 'Draw Hotspot' },
            { tool_type: 'drag',      display_name: 'Edit Shapes'  },
            // { tool_type: 'circle',    display_name: 'Circle'    },
            // { tool_type: 'resize',    display_name: 'Resize'    },
        ];

        return (
            <React.Fragment>
                <Card>
                    <CardContent className="canvas_wrapper">
                        <div 
                            className="canvas" 
                        >
                            <svg
                                onMouseDown={this.handleMouseDown}
                                onMouseUp={this.handleMouseUp}
                                onMouseMove={this.handleMouseMove}
                                ref={this.svgRef}
                                style={{ cursor: this.state.canvasMouseIcon }}
                            >
                                <image href={background_img} />
                                {CanvasFunctions.renderCanvas(obj_list, this.handleMouseDownObj, this.handleMouseUpObj)}
                            </svg>
                        </div>
                    </CardContent>
                    {view_type !== 'detail' ?
                        <CardActions>
                            {tool_list.map((tool_info, index) =>
                                <Button
                                    key={index}
                                    onClick={() => this.handleSelectTool(tool_info.tool_type)}
                                    size="small"
                                    color={(tool_type === tool_info.tool_type) ? 'secondary' : 'primary'}
                                >
                                    {tool_info.display_name}
                                </Button>
                            )}
                        </CardActions>
                    : null}
                </Card>
                {view_type !== 'detail' ?
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>id</TableCell>
                                <TableCell>type</TableCell>
                                <TableCell>xStart</TableCell>
                                <TableCell>yStart</TableCell>
                                <TableCell>xEnd</TableCell>
                                <TableCell>yEnd</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {obj_list.map((obj_info) =>
                                <TableRow key={obj_info.id}>
                                    <TableCell>{obj_info.id}</TableCell>
                                    <TableCell>{obj_info.type}</TableCell>
                                    <TableCell>{obj_info.xStart}</TableCell>
                                    <TableCell>{obj_info.yStart}</TableCell>
                                    <TableCell>{obj_info.xEnd}</TableCell>
                                    <TableCell>{obj_info.yEnd}</TableCell>
                                    <TableCell><Button onClick={() => this.removeObj(obj_info.id)} size="small">Delete</Button></TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>                
                : null}
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addQuestionImageShape:     Actions.addQuestionImageShape,
        updateQuestionImageShape:  Actions.updateQuestionImageShape,
        removeQuestionImageShape:  Actions.removeQuestionImageShape,
        replaceQuestionImageShape: Actions.replaceQuestionImageShape,
    }, dispatch);
}

function mapStateToProps({ quizApp, questionApp, paramHistory }) {
    return {
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CanvasEditor)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/questionType/CanvasEditor.js